import { render, staticRenderFns } from "./additional-seats.vue?vue&type=template&id=25c771de&scoped=true"
import script from "./additional-seats.vue?vue&type=script&lang=js"
export * from "./additional-seats.vue?vue&type=script&lang=js"
import style0 from "./additional-seats.vue?vue&type=style&index=0&id=25c771de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c771de",
  null
  
)

export default component.exports